import type { Countertop } from '../../countertops/countertop.class';

/**
 * False when the island is sold without a top -- `CountertopMaterial.type` is null for the
 * `none` and unresolved keys. Seam rules are properties of the slab, so there is nothing to seam.
 * @param countertop the countertop to test
 * @returns true when a real concrete or granite surface is selected
 */
export const hasCountertopSurface = (countertop: Countertop): boolean => {
	return (countertop?.material?.type ?? null) !== null;
};
